import axios from "axios";

// PATHS
const ENABLE_RECOVERY_DMS_LIST = "/network/ms/recovery/list";
const ENABLE_RECOVERY_GRANT = "/network/ms/recovery/grant";

const fetchEnableRecoveryDmsList: any = async (req: any) => {
    const response = await axios.post(ENABLE_RECOVERY_DMS_LIST, req);
    return response.data;
}

const fetchEnableRecoveryGrants: any = async (req: any) => {
    const response = await axios.post(ENABLE_RECOVERY_GRANT, req);
    return response.data;
}

export {
    fetchEnableRecoveryDmsList,
    fetchEnableRecoveryGrants
}